import { render, staticRenderFns } from "./ReposTable.vue?vue&type=template&id=247abe2b&scoped=true&"
import script from "./ReposTable.vue?vue&type=script&lang=ts&"
export * from "./ReposTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReposTable.vue?vue&type=style&index=0&id=247abe2b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247abe2b",
  null
  
)

export default component.exports